import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  CardText,
} from 'material-ui/Card';
import Checkbox from 'material-ui/Checkbox';
import { theme } from '../../utils/getTheme';
import states from '../../utils/states';

const DataFilter = ({
  collegeRegisterations,
  addFilter,
  removeFilter,
  field,
  // isFieldPresent,
}) => (
  <Card>
      <CardHeader
        title="Select States"
        titleColor={theme.primary1Color}
        actAsExpander
        showExpandableButton
      />
      <CardText expandable style={{ overflow: 'scroll', height: 300 }}>
        {states.map(state => (
          <Checkbox
            key={state.name}
            label={state.name}
            onCheck={(_, checked) => {
              if (checked) {
                addFilter(state.value, collegeRegisterations, field);
              } else {
                removeFilter(state.value, collegeRegisterations, field);
              }
            }}
          // checked={isFieldPresent(field, state.value)}
          />
        ))}
      </CardText>
    </Card>
  );

DataFilter.propTypes = {
  collegeRegisterations: PropTypes.array.isRequired, // eslint-disable-line
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  field: PropTypes.string.isRequired,
  // isFieldPresent: PropTypes.func.isRequired,
};

export default DataFilter;



// WEBPACK FOOTER //
// ./src/components/Filters/DataFilter.js